// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"188":"phone-number-requests","336":"client-profile-settings"}[chunkId] + "." + {"188":"a6b8112aa827","336":"f46986e08913"}[chunkId] + ".chunk.min.js";
};